import Restart16 from '@carbon/icons-react/es/restart/16';
import React, { FC } from 'react';
import { ApprovalRequestChangesRequested } from 'api/notifications/meta';
import { useTranslation } from 'hooks/use-translation';
import { ApprovalComment } from './approval-comment';

export const ApprovalRequestChangeComment: FC<{
  meta: ApprovalRequestChangesRequested;
}> = ({ meta: { message } }) => {
  const fallback = useTranslation('approvals.change_required');

  return (
    <ApprovalComment
      content={message?.content ?? fallback}
      icon={<Restart16 />}
      background="var(--coolest-gray-10)"
    />
  );
};
